import { useEffect } from 'react';
import { bridge, isApp } from 'shared/src/utils';

import { useGetCommonParams } from './useGetCommonParams';

export const useReportTTFD = () => {
  const { instanceId } = useGetCommonParams();

  useEffect(() => {
    if (!instanceId) {
      return;
    }
    if (isApp()) {
      bridge.reportTTFD({ instanceId });
    }
  }, [instanceId]);
};
